import React, { useRef, useState } from "react";
import Slider from "react-slick";
import { settings } from "./settings";
import "./styles.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import photoOne from "../../assets/photos/UNM_HS-Wellness_Art-Walk-4-1_WEB.jpg";
import photoTwo from "../../assets/photos/UNM_HS-Wellness_Art-Walk-4-2_WEB.jpg";
function SectionOne(props) {
  const slider = useRef(null);

  const [oldSlide, setOldSlide] = useState(0);
  const [activeSlide, setActiveSlide] = useState(0);
  const [activeSlide2, setActiveSlide2] = useState(0);

  console.log(slider)


  return (
    <div>
      <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-1">
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-[40%_60%]">
          <div className="tw-flex tw-flex-col tw-ml-8 md:tw-p-8 md:tw-ml-0 lg:tw-justify-center lg:tw-p-10 xl:tw-px-13 tw-pt-4">
            <h1 className="intro tw-text-whte tw-text-6xl lg:tw-text-[4.0rem] lg:tw-leading-[4rem] xl:tw-text-[5.0rem] xl:tw-leading-[5rem] tw-font-bold">
              HSC
              <br />
              Wellness
              <br />
              Art <span className="tw-italic">Walk</span>
            </h1>
            <div className="tw-relative tw-pt-2 tw-h-[50px]">
              <span
                onClick={() => props.change()}
                className="tw-cursor-pointer tw-absolute tw-italic tw-block tw-font-bold  tw-max-w-xs tw-transition tw-duration-300 tw-ease-in-out hover:tw-scale-110"
              >
                view map
              </span>
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-1 tw-relative">
            <div className="tw-ml-8 lg:tw-mr-0 mt-8   tw-items-stretch tw-flex tw-flex-column  lg:tw-hidden">
              <div className="tw-w-full tw-flex tw-items-center tw-justify-center tw-p-6 tw-flex tw-bg-secondary tw-p-12 tw-font-bold tw-uppercase tw-tracking-[3px] tw-items-stretch ">
                1 mile / 2000 Steps
              </div>
            </div>
            <div className="tw-relative">
              <Slider ref={slider} {...settings}>
                <div className="tw-outline-[0] tw-mx-0 mt-0 !tw-block">
                  <div className="tw-bg-[#056d7d] !tw-block">
                    <img
                      className="tw-relative  lg:tw-w-[100%]  tw-without-ring focus:tw-ring-0 focus:tw-ring-offset-0 tw-block"
                      src={photoOne}
                      alt="Water Features"
                    />
                  </div>
                </div>
                <div className="tw-outline-[0] tw-mx-0 !tw-block">
                  <div className="tw-bg-[#056d7d] tw-block">
                    <img
                      className="tw-relative  lg:tw-w-[100%]  tw-without-ring tw-block"
                      src={photoTwo}
                      alt="Water Features"
                    />{" "}
                  </div>
                </div>
              </Slider>
         
            </div>
            <div className="sectionNumber tw-absolute tw-font-bold xl:tw-text-[11.0rem] xl:tw-leading-[11.0rem]">
              1
            </div>
          </div>
        </div>
        <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-[40%_60%]">
          <div className="tw-flex-1 tw-tracking-widest tw-hidden lg:tw-flex tw-flex-column tw-bg-secondary tw-justify-center">
            <div className="tw-text-center tw-font-bold tw-uppercase tw-tracking-[6px] tw-flex tw-flex-column tw-justify-center tw-items-center">
              1 mile / 2000 Steps
            </div>
          </div>
          <div>
            <div>
              <div className="tw-grid tw-grid-cols-1  lg:tw-grid-cols-[100%]">
                <div className="xl:tw-hidden"></div>
                <div className="tw-flex tw-ml-8  tw-justify-center tw-items-end tw-pt-2">
                  <button onClick={() => slider?.current?.slickPrev()} className="tw-items-center tw-flex tw-mr-4 tw-text-sm tw-justify-center "><ChevronLeftIcon className="tw-h-6 tw-w-6 tw-text-white hover:tw-opacity-50" /></button>
                  <button onClick={() => slider?.current?.slickNext()} className="tw-items-center tw-flex tw-text-sm tw-justify-center "><ChevronRightIcon className="tw-h-6 tw-w-6 tw-text-white hover:tw-opacity-50" /></button>
                </div>
                <div className="tw-px-4 lg:tw-pl-[3.25rem] tw-pt-[2.0rem] lg:tw-pt-[3.25rem] lg:tw-px-[4.25rem] lg:tw-pt-[3.25rem] tw-relative">
                <div>
                
            
              </div>
                  <p className="tw-font-bold tw-italic tw-mb-4 tw-mb-0 tw-border-t-[1px] tw-border-white tw-pt-3 tw-text-2xl tw-w-1/2 tw-text-2xl tw-w-1/2">
                    Water Features
                  </p>
                  <p className="text-2xl">
                    South of the Collaborative Shade Structure on the upper
                    plaza of the HSC North Campus are two seasonal water
                    features that open the eye and ear to thoughts of nature and
                    the wellness that many find in the sound of water and shape
                    of desert rock forms.
                  </p>
                </div>

                <div className="border-bottom tw-relative tw-hidden lg:tw-block">
                  <div className="sectionNumber-hr tw-ml-[auto]"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default SectionOne;
